module.exports = __webpack_public_path__ + "img/sgc_logo.5fbb2d7d.png";